module.exports = __webpack_public_path__ + "static/img/img-responsive.1a14e9b0.jpg";